import { AfterViewInit,Component, Inject, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import { DialogBoxComponent } from './dialog-box.component';
import { ControlService } from 'app/main/services/control.service';
import { RiesgoService } from 'app/main/services/riesgo.service';
import { EstructuraJerarquicaService } from 'app/main/services/estructura-jerarquica.service';
import { Control } from 'app/main/models/control.model';
import { Riesgo } from 'app/main/models/riesgo.model';
import { EstructuraJerarquica } from 'app/main/models/estructura-jerarquica.model';
import { ControlSugerido } from 'app/main/models/control-sugerido.model';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

const Parser = require('expr-eval').Parser;

import {TranslateService} from '@ngx-translate/core';

import {MatAutocompleteTrigger} from '@angular/material/autocomplete';



@Component({
  selector: 'app-dialog-box',
  templateUrl: './add-control-sugerido-dialog-box.component.html',
  styleUrls: ['./add-control-sugerido-dialog-box.component.scss']
})
export class AddControlSugeridoDialogBoxComponent {

  action: string;
  data: ControlSugerido = {id:null,control:null,nodo:null,estructura:null,riesgo:null,
                            responsable:null,referente:null};

  controles: Control[] = [];

  controlesSugeridos:ControlSugerido[] = [];
  estructura: EstructuraJerarquica = null;
  riesgos: Riesgo[] = [];

  lastTypedControl:string ="";
  myControl = new FormControl();
  filteredControles: Observable<Control[]>;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;


  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    public controlService: ControlService,
    public riesgosService : RiesgoService,
    public serviceEstructuraJerarquica: EstructuraJerarquicaService,
    public dialogRef: MatDialogRef<AddControlSugeridoDialogBoxComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public dataIn: any) {

      this.controlesSugeridos = dataIn.controlesSugeridos;
      this.action = dataIn.action;
      this.estructura = dataIn.estructura;
      this.riesgos = dataIn.riesgos;
      if(this.action=='Update' || this.action=='Delete' || this.action=='View' ){
        this.data = dataIn.obj;
      }
      if(this.data.nodo==null){
        this.data.estructura = dataIn.estructura;
        this.data.nodo = dataIn.nodo;
      }
  }

  doAction(): void{
    if(this.existControlRiesgo()){
      alert("Ya existe un control con el riesgo "+this.data.riesgo.nombre +" y el control "+this.data.control.nombre );
    }else{
      this.dialogRef.close({event: this.action, data: this.data});
    }
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
      width: '100%',
      data: {estructura:this.estructura,action:'ADD'}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.data.nodo = result.data.nodo;
      this.data.estructura = result.data.estructura;
      this.data.referente = null;
    });
  }


  ngOnInit(): void {

    this.controlService.getAll(0,1000).pipe().subscribe(req => {
      this.controles = req.body.map( control => {
        console.log(control);
        return {
          id: control.id,
          nombre: control.nombre,
          categoria: control.categoria
        };
      });

      this.filteredControles = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
      );

      if(this.action=='View' || this.action=='Delete'){
        this.myControl.disable();
      }


    });



  }

  private _filter(value: String): Control[] {
      if(typeof value === "string"){
        const filterValue = value.toLowerCase();
        this.lastTypedControl = value;
        return this.controles.filter(option => option.nombre.toLowerCase().includes(filterValue));
      }
      //return this.controles.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);

  }

  /*
  displayFn(value?: Control) {
    return value ? this.controles.find(_ => _.id === value.id).nombre : undefined;
  }*/

  displayFn(value?: Control) {
    var retorno = "";
    if(value!=null && typeof value=="object")
      retorno = this.controles.find(_ => _.id === value.id).nombre;
    if(value!=null && typeof value=="number")
        retorno = this.controles.find(_ => _.id === value).nombre;
    if(value == null && this.data.control!=null)
        retorno = this.data.control.nombre;
    return retorno;
  }

   public agregarControl():void{
     const dialogRef = this.dialog.open(DialogBoxComponent, {
         width: '100%',
         data: {obj:{nombre:this.lastTypedControl},action:'Add',dataSource:this.controles,autocomplete:false},
         disableClose: true
       });

       dialogRef.afterClosed().subscribe(result => {
         this.controles = [...result.dataSource];
         this.data.control = {...result.data};
         this.autocomplete.closePanel();

       });
  }

  compareObjects(o1: any, o2: any): boolean {
    var equals = false;
    if(o1!=null && o2!=null && typeof o1 === 'object' &&  typeof o2 === 'object' && 'id' in o1 && 'id' in o2 && o1.id === o2.id){
      equals = true;
    }else{
      equals = (o1 == o2)? true:false;
    }

    return equals;
  }

  setLocal(option):void{
    this.data.control = option;
  }

  existControlRiesgo():boolean{
    var exist = false;
    this.controlesSugeridos.forEach(control => {
      if(control.control.id === this.data.control.id && control.riesgo.id === this.data.riesgo.id &&
         this.data.id !=null && this.data.id !=  control.id)
        exist = true;
    });

    return exist;
  }

}
